import { baseEachRight } from './base'

export default function forEachRight(data, iteratee) {
  return baseEachRight(data, iteratee)
}
